/*
 * gdpr Popup
*/
	const siteCookies = document.querySelector('[site-cookies]')

	if (siteCookies) {
		const siteCookiesCheck = localStorage.getItem('privacy_terms_accepted')
		const siteCookiesDismiss = siteCookies.querySelectorAll('[site-cookies-dismiss]')

		window.addEventListener('load', _ => {
			setTimeout(() => {
				if (!siteCookiesCheck) {
					siteCookies.classList.add('is--shown')
					siteCookiesDismiss[0].focus()
				} else {
					siteCookies.remove()
				}
			}, 3000)
		})

		siteCookiesDismiss.forEach(e => {
			e.addEventListener('click', _ => {
				siteCookies.classList.add('is--hide')
				siteCookies.classList.remove('is--shown')
				localStorage.setItem('privacy_terms_accepted', true)

				setTimeout(function () {
					siteCookies.remove()
				}, 300)
			})
		})
	}
